import React, { Component } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import Background from '../../common/images/side-bg.jpg';
import loginImg from "../../common/images/login-logo.png"
class MenuSidebar extends Component {
	
	constructor(props)
	{
		super(props);
		this.state = {
			  currentpage:this.props.currentpage,
			  admin_id:localStorage.getItem('admin_id')
		};
		
    }
	
	activeMenu(currentPage) {
        let status = '';
            if(this.state.currentpage===currentPage) {
                status = 'nav-item has-sub active'
            }else{
            status = 'nav-item has-sub enable';
        }
        return status;
    }
	
  render() {
    return (	
	<div className="sidebar-menu mobi-close">
	   <div className="main-menu menu-fixed menu-dark menu-accordion menu-shadow expanded" data-scroll-to-active="true" >
  <div className="navbar-header expanded">
    <ul className="nav navbar-nav flex-row position-relative">
      <li className="nav-item mr-auto">
        <a className="navbar-brand" href="#">
        {/* <img src={loginImg} /> */}
          <h3 className="brand-text">Admin</h3>
        </a>
      </li>
      <li className="nav-item d-md-none"><a href="javascript:void(0)" className="nav-link close-navbar mb-side-nav"><i className="ft-x"></i></a></li>
    </ul>
  </div>
  <div className="navigation-background" style={{background: `url(${Background})`}}></div>
  <div className="main-menu-content ps ps--active-y" style={{height: "587px;"}}>
  <Scrollbars className="custom-scroll-wrap">
    <ul className="navigation navigation-main" id="main-menu-navigation" data-menu="menu-navigation">
      <li className={this.activeMenu('dashboard')}>
        <a href="/dashboard">
          <i className="ft-home"></i>
          <span className="menu-title" data-i18n="">Dashboard</span>
        </a>
      </li>
      {this.state.admin_id == 1 ?<li className={this.activeMenu('companylist')}>
					<a title="Company" href="/company">
						<i className="ft-company" aria-hidden="true"></i>
						<span>Companies</span>
					</a>
		        </li>:''} 
      <li className={this.activeMenu('rehabs')}>
        <a title="Rehaps" href="/rehabs">
          <i className="ft-rehab-users"></i>
          <span className="menu-title" data-i18n="">Rehabs</span>
        </a>
      </li>
   
          

            <li className={this.activeMenu('user')}>
        <a title="User" href="/user">
          <i className="ft-users"></i>
          <span className="menu-title" data-i18n="">Users</span>
        </a>
      </li>
      <li className={this.activeMenu('drivers')}>
        <a title="Driver" href="/drivers">
          <i className="ft-users"></i>
          <span className="menu-title" data-i18n="">Drivers</span>
        </a>
      </li>
      <li className={this.activeMenu('appointments')}>
        <a title="Appointments" href="/appointments">
          <i className="ft-app-users"></i>
          <span className="menu-title" data-i18n=""> New Appts</span>
        </a>
      </li>
      <li className={this.activeMenu('appointment-assigned')}>
        <a title="Appointments" href="/appointment-assigned">
          <i className="ft-app-users"></i>
          <span className="menu-title" data-i18n="">Assigned Appts</span>
        </a>
      </li>
      <li className={this.activeMenu('appointment-observation')}>
        <a title="Appointments" href="/appointment-observation">
          <i className="ft-app-users"></i>
          <span className="menu-title" data-i18n="">Completed Appts</span>
        </a>
      </li>
      <li className={this.activeMenu('userDispute')}>
        <a href="/userDispute">
          <i className="ft-type"></i>
          <span className="menu-title" data-i18n="">User Disputes</span>
        </a>
      </li>
       {/* <li className={this.activeMenu('plugincontent')}>
					<a href="/plugincontent">
						<i className="ft-edit" aria-hidden="true"></i>
						<span className="menu-title" data-i18n="">Plugin Content</span>
					</a>
				</li> */}
 <li className={this.activeMenu('tabmanagement')}>
        <a href="/tabmanagement">
          <i className="ft-tab-management"></i>
          <span className="menu-title" data-i18n="">Tab Management</span>
        </a>
      </li>
      <li className={this.activeMenu('dashboardmanagement')}>
        <a title="Dashboard Management Builder" href="/dashboardmanagement">
          <i className="ft-tab-management"></i>
          <span className="menu-title" data-i18n="" >Dashboard Management</span>
        </a>
      </li>
      <li className={this.activeMenu('amenities')}>
        <a href="/amenities">
          <i className="ft-tab-management"></i>
          <span className="menu-title" data-i18n="">Amenities</span>
        </a>
      </li>
      {this.state.admin_id == 1 ?<li className={this.activeMenu('vehicles')}>
        <a href="/vehicles">
          <i className="ft-feather"></i>
          <span className="menu-title" data-i18n="">Vehicles</span>
        </a>
      </li>:''} 
      <li className={this.activeMenu('raiseDispute')}>
        <a href="/raiseDispute">
          <i className="ft-type"></i>
          <span className="menu-title" data-i18n="">Raise Dispute</span>
        </a>
      </li>
      <li className={this.activeMenu('offerCms')}>
        <a title="Offer CMS" href="/Cms">
          <i className="ft-rehab-users"></i>
          <span className="menu-title" data-i18n="">Offers</span>
        </a>
      </li>
      <li className={this.activeMenu('adsCategory')}>
        <a title="Advertisement" href="/adsCategory">
          <i className="ft-rehab-users"></i>
          <span className="menu-title" data-i18n="">Advertisement Category</span>
        </a>
      </li>
      <li className={this.activeMenu('advertisement')}>
        <a title="Advertisement" href="/advertisement">
          <i className="ft-rehab-users"></i>
          <span className="menu-title" data-i18n="">Advertisement</span>
        </a>
      </li>
      <li className={this.activeMenu('coupon')}>
        <a title="Coupon" href="/coupon">
          <i className="ft-users"></i>
          <span className="menu-title" data-i18n="">Coupon</span>
        </a>
      </li>
      <li className={this.activeMenu('GuideCategory')}>
        <a href="/GuideCategory">
          <i className="ft-faq" aria-hidden="true"></i>
          <span className="menu-title" data-i18n="">Guide Categories</span>
        </a>
      </li>
      <li className={this.activeMenu('GuideSubCategory')}>
        <a href="/GuideSubCategory">
          <i className="ft-faq" aria-hidden="true"></i>
          <span className="menu-title" data-i18n="">Guide Sub Categories</span>
        </a>
      </li>
      <li className={this.activeMenu('guide')}>
        <a href="/guide">
          <i className="ft-tab-management"></i>
          <span className="menu-title" data-i18n="">Guide</span>
        </a>
      </li>
      <li className={this.activeMenu('MembershipCategory')}>
        <a href="/membershipcategory">
          <i className="ft-membership" aria-hidden="true"></i>
          <span className="menu-title" data-i18n="">Membership Categories</span>
        </a>
      </li>

      <li className={this.activeMenu('membership')}>
        <a href="/membership">
          <i className="ft-membership"></i>
          <span className="menu-title" data-i18n="">Memberships</span>
        </a>
      </li>
      <li className={this.activeMenu('gallery')}>
        <a href="/gallery">
          <i className="ft-gallery"></i>
          <span className="menu-title" data-i18n="">Gallery</span>
        </a>
      </li>
      <li className={this.activeMenu('FaqCategory')}>
        <a href="/Faqcategory">
          <i className="ft-faq-category" aria-hidden="true"></i>
          <span className="menu-title" data-i18n="">Faq Category</span>
        </a>
      </li>

      <li className={this.activeMenu('Faq')}>
        <a href="/Faq">
          <i className="ft-faq" aria-hidden="true"></i>
          <span className="menu-title" data-i18n="">Faq</span>
        </a>
      </li>

      <li className={this.activeMenu('Aifeed')}>
        <a href="/aifeed">
          <i className="ft-faq" aria-hidden="true"></i>
          <span className="menu-title" data-i18n="">Manage AI Feed</span>
        </a>
      </li>
      <li className={this.activeMenu('fonts')}>
        <a href="/fonts">
          <i className="ft-type"></i>
          <span className="menu-title" data-i18n="">Fonts</span>
        </a>
      </li>
      {this.state.admin_id == 1 ?<li className={this.activeMenu('templates')}>
        <a href="/templates">
          <i className="ft-feather"></i>
          <span className="menu-title" data-i18n="">Templates</span>
        </a>
        </li>:''} 
	    <li className={this.activeMenu('setting')}>
        <a href="/setting">
          <i className="ft-settings"></i>
          <span className="menu-title" data-i18n="">Settings</span>
        </a>
      </li>
      
    </ul>
    </Scrollbars>
  </div>
</div>
	</div>		

	
    );
  }
}

export default MenuSidebar;